import { ref, onBeforeMount, onBeforeUnmount, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

const WIDTH = 992 // refer to Bootstrap's responsive design

export default function useResize() {
  const store = useStore()
  const route = useRoute()
  
  // 计算当前是否为移动设备
  const isMobile = () => {
    const rect = document.body.getBoundingClientRect()
    return rect.width - 1 < WIDTH
  }
  
  // 处理窗口大小变化
  const resizeHandler = () => {
    if (!document.hidden) {
      const mobile = isMobile()
      store.dispatch('app/toggleDevice', mobile ? 'mobile' : 'desktop')

      if (mobile) {
        store.dispatch('app/closeSideBar', { withoutAnimation: true })
      }
    }
  }
  
  // 监听路由变化
  watch(() => route.path, () => {
    const device = store.state.app.device
    const sidebar = store.state.app.sidebar
    
    if (device === 'mobile' && sidebar.opened) {
      store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  })
  
  // 生命周期钩子
  onBeforeMount(() => {
    window.addEventListener('resize', resizeHandler)
  })
  
  onBeforeUnmount(() => {
    window.removeEventListener('resize', resizeHandler)
  })
  
  onMounted(() => {
    const mobile = isMobile()
    if (mobile) {
      store.dispatch('app/toggleDevice', 'mobile')
      store.dispatch('app/closeSideBar', { withoutAnimation: true })
    }
  })
  
  return {
    isMobile,
    resizeHandler
  }
}